module.exports = __webpack_public_path__ + "img/woman.6bd22065.png";